import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import useParseHtml from "@hooks/useParseHtml";
const ParsedHtml = ({ html }) => {
    const content = useParseHtml(html);
    return content ? _jsx(_Fragment, { children: content }) : null;
};
export default ParsedHtml;
